export const CAROUSEL_PROPERTY_LIMIT = 8;
